// GENERATED FILE, PLEASE DO NOT EDIT
var SystemGrey0 = '#F7F7F7';
var SystemGrey5 = '#E7E7E7';
var SystemGrey10 = '#D6D6D6';
var SystemGrey20 = '#C4C4C4';
var SystemGrey30 = '#B2B2B2';
var SystemGrey40 = '#9F9F9F';
var SystemGrey50 = '#8B8B8B';
var SystemGrey60 = '#767676';
var SystemGrey70 = '#606060';
var SystemGrey80 = '#494949';
var SystemGrey90 = '#313131';
var SystemGrey95 = '#242424';
var SystemGrey100 = '#191919';
var SystemRed0 = '#FFF7F5';
var SystemRed5 = '#FFF0ED';
var SystemRed10 = '#FFE0DB';
var SystemRed20 = '#FEC7BD';
var SystemRed30 = '#FDA294';
var SystemRed40 = '#FA7463';
var SystemRed50 = '#F54323';
var SystemRed60 = '#EB1700';
var SystemRed70 = '#D91400';
var SystemRed80 = '#B71000';
var SystemRed90 = '#810B00';
var SystemRed100 = '#380500';
var SystemYellow0 = '#FFFFEB';
var SystemYellow5 = '#FFFFA3';
var SystemYellow10 = '#FEFF58';
var SystemYellow20 = '#F6E61B';
var SystemYellow30 = '#E8C500';
var SystemYellow40 = '#D5A600';
var SystemYellow50 = '#BD8800';
var SystemYellow60 = '#A16C00';
var SystemYellow70 = '#835200';
var SystemYellow80 = '#643B00';
var SystemYellow90 = '#452700';
var SystemYellow100 = '#261500';
var SystemGreen0 = '#F6FFFA';
var SystemGreen5 = '#E7FBEF';
var SystemGreen10 = '#CEF4DD';
var SystemGreen20 = '#A9E9C1';
var SystemGreen30 = '#7BD89D';
var SystemGreen40 = '#4BC275';
var SystemGreen50 = '#1FA74F';
var SystemGreen60 = '#00872F';
var SystemGreen70 = '#006A25';
var SystemGreen80 = '#004C1B';
var SystemGreen90 = '#002F10';
var SystemGreen100 = '#001206';
var SystemTeal0 = '#F5FFFF';
var SystemTeal5 = '#ECFCFC';
var SystemTeal10 = '#D7F5F5';
var SystemTeal20 = '#B6E9EA';
var SystemTeal30 = '#8BD8DA';
var SystemTeal40 = '#5BC1C4';
var SystemTeal50 = '#2AA4A9';
var SystemTeal60 = '#00838A';
var SystemTeal70 = '#00666D';
var SystemTeal80 = '#00494E';
var SystemTeal90 = '#002C2F';
var SystemTeal100 = '#001012';
var SystemBlue0 = '#fafbff';
var SystemBlue5 = '#f4f6fe';
var SystemBlue10 = '#e6ebfd';
var SystemBlue20 = '#d1dafb';
var SystemBlue30 = '#b4c2fa';
var SystemBlue40 = '#91a5f9';
var SystemBlue50 = '#6c87fb';
var SystemBlue60 = '#4969f5';
var SystemBlue70 = '#2a4de4';
var SystemBlue80 = '#1537c7';
var SystemBlue90 = '#082496';
var SystemBlue100 = '#02124f';
var SystemWhite = '#ffffff';
var SystemBlack = '#191919';
var SystemBlackPure = '#000000';
var BrandRedBase = '#FF3008';
var BrandRedDark = '#DE3725';
var BrandSkyLight = '#E1F6FA';
var BrandSkyBase = '#D1F0F6';
var BrandSkyDark = '#BEDFE9';
var BrandSkyText = '#24809C';
var BrandLemonLight = '#FCF89A';
var BrandLemonBase = '#FAF258';
var BrandLemonDark = '#F8E500';
var BrandOceanLight = '#73A3A6';
var BrandOceanBase = '#518C8F';
var BrandOceanDark = '#3A646E';
var BrandOceanText = '#00838A';
var BrandFlushLight = '#FAE4E1';
var BrandFlushBase = '#F3D1CD';
var BrandFlushDark = '#E5BBB7';
var BrandFlushText = '#CE483B';
var BrandForestLight = '#61786D';
var BrandForestBase = '#3A5648';
var BrandForestDark = '#28362C';
var BrandStoneLight = '#E6E5D8';
var BrandStoneBase = '#C6C5B6';
var BrandStoneDark = '#666666';
var ColorTokensAll = {
  BrandFlushBase: BrandFlushBase,
  BrandFlushDark: BrandFlushDark,
  BrandFlushLight: BrandFlushLight,
  BrandFlushText: BrandFlushText,
  BrandForestBase: BrandForestBase,
  BrandForestDark: BrandForestDark,
  BrandForestLight: BrandForestLight,
  BrandLemonBase: BrandLemonBase,
  BrandLemonDark: BrandLemonDark,
  BrandLemonLight: BrandLemonLight,
  BrandOceanBase: BrandOceanBase,
  BrandOceanDark: BrandOceanDark,
  BrandOceanLight: BrandOceanLight,
  BrandOceanText: BrandOceanText,
  BrandRedBase: BrandRedBase,
  BrandRedDark: BrandRedDark,
  BrandSkyBase: BrandSkyBase,
  BrandSkyDark: BrandSkyDark,
  BrandSkyLight: BrandSkyLight,
  BrandSkyText: BrandSkyText,
  BrandStoneBase: BrandStoneBase,
  BrandStoneDark: BrandStoneDark,
  BrandStoneLight: BrandStoneLight,
  SystemBlack: SystemBlack,
  SystemBlackPure: SystemBlackPure,
  SystemBlue0: SystemBlue0,
  SystemBlue10: SystemBlue10,
  SystemBlue100: SystemBlue100,
  SystemBlue20: SystemBlue20,
  SystemBlue30: SystemBlue30,
  SystemBlue40: SystemBlue40,
  SystemBlue5: SystemBlue5,
  SystemBlue50: SystemBlue50,
  SystemBlue60: SystemBlue60,
  SystemBlue70: SystemBlue70,
  SystemBlue80: SystemBlue80,
  SystemBlue90: SystemBlue90,
  SystemGreen0: SystemGreen0,
  SystemGreen10: SystemGreen10,
  SystemGreen100: SystemGreen100,
  SystemGreen20: SystemGreen20,
  SystemGreen30: SystemGreen30,
  SystemGreen40: SystemGreen40,
  SystemGreen5: SystemGreen5,
  SystemGreen50: SystemGreen50,
  SystemGreen60: SystemGreen60,
  SystemGreen70: SystemGreen70,
  SystemGreen80: SystemGreen80,
  SystemGreen90: SystemGreen90,
  SystemGrey0: SystemGrey0,
  SystemGrey10: SystemGrey10,
  SystemGrey100: SystemGrey100,
  SystemGrey20: SystemGrey20,
  SystemGrey30: SystemGrey30,
  SystemGrey40: SystemGrey40,
  SystemGrey5: SystemGrey5,
  SystemGrey50: SystemGrey50,
  SystemGrey60: SystemGrey60,
  SystemGrey70: SystemGrey70,
  SystemGrey80: SystemGrey80,
  SystemGrey90: SystemGrey90,
  SystemGrey95: SystemGrey95,
  SystemRed0: SystemRed0,
  SystemRed10: SystemRed10,
  SystemRed100: SystemRed100,
  SystemRed20: SystemRed20,
  SystemRed30: SystemRed30,
  SystemRed40: SystemRed40,
  SystemRed5: SystemRed5,
  SystemRed50: SystemRed50,
  SystemRed60: SystemRed60,
  SystemRed70: SystemRed70,
  SystemRed80: SystemRed80,
  SystemRed90: SystemRed90,
  SystemTeal0: SystemTeal0,
  SystemTeal10: SystemTeal10,
  SystemTeal100: SystemTeal100,
  SystemTeal20: SystemTeal20,
  SystemTeal30: SystemTeal30,
  SystemTeal40: SystemTeal40,
  SystemTeal5: SystemTeal5,
  SystemTeal50: SystemTeal50,
  SystemTeal60: SystemTeal60,
  SystemTeal70: SystemTeal70,
  SystemTeal80: SystemTeal80,
  SystemTeal90: SystemTeal90,
  SystemWhite: SystemWhite,
  SystemYellow0: SystemYellow0,
  SystemYellow10: SystemYellow10,
  SystemYellow100: SystemYellow100,
  SystemYellow20: SystemYellow20,
  SystemYellow30: SystemYellow30,
  SystemYellow40: SystemYellow40,
  SystemYellow5: SystemYellow5,
  SystemYellow50: SystemYellow50,
  SystemYellow60: SystemYellow60,
  SystemYellow70: SystemYellow70,
  SystemYellow80: SystemYellow80,
  SystemYellow90: SystemYellow90
};

export { BrandFlushBase, BrandFlushDark, BrandFlushLight, BrandFlushText, BrandForestBase, BrandForestDark, BrandForestLight, BrandLemonBase, BrandLemonDark, BrandLemonLight, BrandOceanBase, BrandOceanDark, BrandOceanLight, BrandOceanText, BrandRedBase, BrandRedDark, BrandSkyBase, BrandSkyDark, BrandSkyLight, BrandSkyText, BrandStoneBase, BrandStoneDark, BrandStoneLight, ColorTokensAll, SystemBlack, SystemBlackPure, SystemBlue0, SystemBlue10, SystemBlue100, SystemBlue20, SystemBlue30, SystemBlue40, SystemBlue5, SystemBlue50, SystemBlue60, SystemBlue70, SystemBlue80, SystemBlue90, SystemGreen0, SystemGreen10, SystemGreen100, SystemGreen20, SystemGreen30, SystemGreen40, SystemGreen5, SystemGreen50, SystemGreen60, SystemGreen70, SystemGreen80, SystemGreen90, SystemGrey0, SystemGrey10, SystemGrey100, SystemGrey20, SystemGrey30, SystemGrey40, SystemGrey5, SystemGrey50, SystemGrey60, SystemGrey70, SystemGrey80, SystemGrey90, SystemGrey95, SystemRed0, SystemRed10, SystemRed100, SystemRed20, SystemRed30, SystemRed40, SystemRed5, SystemRed50, SystemRed60, SystemRed70, SystemRed80, SystemRed90, SystemTeal0, SystemTeal10, SystemTeal100, SystemTeal20, SystemTeal30, SystemTeal40, SystemTeal5, SystemTeal50, SystemTeal60, SystemTeal70, SystemTeal80, SystemTeal90, SystemWhite, SystemYellow0, SystemYellow10, SystemYellow100, SystemYellow20, SystemYellow30, SystemYellow40, SystemYellow5, SystemYellow50, SystemYellow60, SystemYellow70, SystemYellow80, SystemYellow90, ColorTokensAll as default };
